// extracted by mini-css-extract-plugin
export var borderRadius = "_9b-4";
export var large = "_9b-3";
export var logoContainer = "_9b-0";
export var nameLogo = "_9b-2";
export var small = "_9b-1";